import React, { useState, useEffect } from "react";
import GeneralConfig from "./Configurations/GeneralConfig";
import EventConfig from "./Configurations/EventConfig";
import DynamicTab from "src/components/tab/DynamicTab";
import { useLocation, useNavigate } from "react-router-dom";

const tabsData = [
	{ 
		label: "General", 
		component: GeneralConfig,
		pathname: "general" 
	},
	{ 
		label: "Event Config", 
		component: EventConfig,
		pathname: "event_config"
	},
];

export default function ConfigPage() {
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  const initialTabPathName = queryParams.get("tab") || tabsData[0].pathname; // Default to first tab's label
  const [activeTabPathName, setActiveTabPathName] = useState(initialTabPathName);

  // Set URL with default tab label on initial load if not present
  useEffect(() => {
    if (!queryParams.get("tab")) {
      navigate(`/dashboard/config?tab=${encodeURIComponent(tabsData[0].pathname)}`, { replace: true });
    }
  }, []);
  
  const handleTabChange = (newTabPathName) => {
    setActiveTabPathName(newTabPathName);
    navigate(`/dashboard/config?tab=${encodeURIComponent(newTabPathName)}`, { replace: true });
  };

  useEffect(() => {
    const currentTabPathName = queryParams.get("tab") || tabsData[0].pathname;
    if (currentTabPathName !== activeTabPathName) {
		setActiveTabPathName(currentTabPathName);
    }
  }, [location.search]);

  return (
    <DynamicTab
      tabs={tabsData}
      activeTabPathName={activeTabPathName} // Pass label instead of index
      onTabChange={handleTabChange}
    />
  );
}